"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M19 1.01 5.01 1v22H19zM17 19H7V5h10z"
}), 'StayCurrentPortraitSharp');